import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";

import { useState } from "react";

import AdvertisementReport from "./AdvertisementReport";
const AdvertisementReportDialog = (props) => {
  const { showAdvertisementReport, setShowAdvertisementReport, advertisement } =
    props;

  const [maxWidth, setMaxWidth] = useState("lg");
  const onClose = () => {
    setShowAdvertisementReport(false);
  };
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAdvertisementReport}
        fullWidth
        maxWidth={maxWidth}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span>Report</span> /{" "}
            <span className="badge badge-info">
              {advertisement?.statusName || "Draft"}
            </span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="mt-0 mx-0" dividers>
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <AdvertisementReport
              details={{
                ...advertisement,
                advertisementId:
                  advertisement?.advertismentId || advertisement?.id,
                npscReportId: advertisement?.npscReportId || 0,
              }}
              canApproveCandidates={false}
            />
          </Box>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center py-2">
             
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdvertisementReportDialog;
